import { DateTime, Duration } from 'luxon';
import { WORK_ORDER_STATUS_CANCELLED, WORK_ORDER_STATUS_COMPLETED, WORK_ORDER_STATUS_INVOICED } from '@/constants/workOrders';

const FINISHED_STATUSES = [ WORK_ORDER_STATUS_CANCELLED, WORK_ORDER_STATUS_COMPLETED, WORK_ORDER_STATUS_INVOICED ];

// Returns the display text and Bootstrap text class for the Open For column.
export function getWorkOrderOpenDuration(workOrder, now = DateTime.now()) {
  if (!workOrder.created_at) {
    return { text: '', isOpen: false, textClass: '' };
  }

  const isOpen = !FINISHED_STATUSES.includes(workOrder.status);
  const start = DateTime.fromISO(workOrder.created_at);
  let end = now;

  if (workOrder.status === WORK_ORDER_STATUS_CANCELLED && workOrder.deleted_at) {
    end = DateTime.fromISO(workOrder.deleted_at);
  } else if (
    (workOrder.status === WORK_ORDER_STATUS_COMPLETED || workOrder.status === WORK_ORDER_STATUS_INVOICED)
    && workOrder.checked_out_at
  ) {
    end = DateTime.fromISO(workOrder.checked_out_at);
  }

  const seconds = Math.max(0, Math.floor(end.diff(start, 'seconds').seconds));
  const duration = Duration.fromObject({ seconds }).shiftTo('days', 'hours', 'minutes', 'seconds');
  const pad = (value) => String(Math.floor(value)).padStart(2, '0');
  const time = `${pad(duration.hours)}:${pad(duration.minutes)}:${pad(duration.seconds)}`;
  const text = duration.days > 0 ? `${Math.floor(duration.days)}d ${time}` : time;

  if (!isOpen) {
    return { text, isOpen: false, textClass: 'text-muted' };
  }

  let textClass = 'text-info';
  if (seconds >= 86400 * 2) {
    textClass = 'text-danger';
  } else if (seconds >= 86400) {
    textClass = 'text-warning';
  }

  return { text, isOpen: true, textClass };
}
